import { HWCInfo } from './HWCInfo.model';


export class Branch {
  public BranchId: number = -1;
  public UID: string = "";
  public BranchName: string = "";
  public BranchHasHWCDongle: boolean = false;
  public HWCDongleInfo: HWCInfo = null;
  public Enabled: boolean = false;
  public HWCUrl: string = "";
  public AptBooKCellDuration: number = 5;
  public JumpToCurrentTime: number = 0;
  public SelectedAptViewId: number = -1;
  public TenantHash: string="";

  public get FoundHWCDongle(): boolean {
    return (this.HWCDongleInfo != null);
  }

  public get BranchNameEx(): string {
    var s = this.BranchName;
    if (this.FoundHWCDongle)
      s = s + " (Local)";
    return s;
  }

  public static CreateFrom(b: Branch): Branch {
    var branch: Branch = new Branch();
    branch.BranchId = b.BranchId;
    branch.UID = b.UID;
    branch.BranchName = b.BranchName;
    branch.BranchHasHWCDongle = b.BranchHasHWCDongle;
    branch.Enabled = b.Enabled;
    branch.HWCDongleInfo = b.HWCDongleInfo;
    branch.HWCUrl = b.HWCUrl;
    branch.AptBooKCellDuration = b.AptBooKCellDuration;
    branch.JumpToCurrentTime = b.JumpToCurrentTime;
    branch.TenantHash = b.TenantHash;

    // Ensure URl does not end in a / or \ as this will stop Routes working correctly.
    if (b.HWCUrl.endsWith('/') || b.HWCUrl.endsWith('\''))
      b.HWCUrl = b.HWCUrl.substring(0, b.HWCUrl.length - 1);
    return branch;
  }

  public get HWCWebApiUrl(): string {
    if (!this.HWCUrl)
      return this.HWCUrl;
    if (this.HWCUrl.endsWith('/') || this.HWCUrl.endsWith('\''))
      this.HWCUrl = this.HWCUrl.substring(0, this.HWCUrl.length - 1);
    return this.HWCUrl;
  }
}
